import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { DefaultButton } from "@fluentui/react/lib/Button";
import { Text } from "@fluentui/react";
import { LTLState } from "@taskpane/hooks/useLTLReducer";
import { itemsEditorStyles as styles } from "./itemsEditor.styles";
import { LtlFreightItemCoreFields } from "./LtlFreightItemCoreFields";
import { LtlFreightItemDimensionsHazmat } from "./LtlFreightItemDimensionsHazmat";

type ItemRow = LTLState["items"][number];

interface LtlFreightItemCardProps {
  item: ItemRow;
  index: number;
  totalItems: number;
  state: LTLState;
  showNmfc: boolean;
  nmfcRequired: boolean;
  onItemFieldChange: (index: number, field: keyof ItemRow, value: unknown) => void;
  onFieldBlur?: () => void;
  onRemoveItem: (index: number) => void;
  getTextFieldStyles: (fieldKey: string) => unknown;
  maxWeight?: number;
}

export function LtlFreightItemCard({
  item,
  index,
  totalItems,
  state,
  showNmfc,
  nmfcRequired,
  onItemFieldChange,
  onFieldBlur,
  onRemoveItem,
  getTextFieldStyles,
  maxWeight,
}: LtlFreightItemCardProps): React.ReactElement {
  return (
    <Box sx={styles.itemContainer}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={styles.itemHeader}
      >
        <Text variant="medium" styles={styles.itemTitle}>
          Freight Item {index + 1}
        </Text>
        {totalItems > 1 && (
          <DefaultButton
            text="Remove"
            onClick={() => onRemoveItem(index)}
            allowDisabledFocus
            styles={styles.removeButton}
          />
        )}
      </Stack>

      <LtlFreightItemCoreFields
        item={item}
        index={index}
        state={state}
        showNmfc={showNmfc}
        nmfcRequired={nmfcRequired}
        onItemFieldChange={onItemFieldChange}
        onFieldBlur={onFieldBlur}
        getTextFieldStyles={getTextFieldStyles}
        maxWeight={maxWeight}
      />
      <LtlFreightItemDimensionsHazmat
        item={item}
        index={index}
        state={state}
        onItemFieldChange={onItemFieldChange}
        onFieldBlur={onFieldBlur}
        getTextFieldStyles={getTextFieldStyles}
      />

      {index < totalItems - 1 && <Box sx={styles.itemDivider} />}
    </Box>
  );
}
